import clsx from 'clsx'

interface StepLoadingIconProps {
  className?: string
}

export const StepLoadingIcon = ({ className }: StepLoadingIconProps) => {
  return (
    <svg
      width="48"
      height="49"
      viewBox="0 0 48 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={clsx('animate-spin', className)}
    >
      <mask
        id="mask0_2151_8484"
        style={{ maskType: 'alpha' }}
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="48"
        height="49"
      >
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24 4.79492C18.8283 4.79492 13.8684 6.84938 10.2114 10.5063C6.55446 14.1633 4.5 19.1232 4.5 24.2949C4.5 29.4666 6.55446 34.4265 10.2114 38.0835C13.8684 41.7405 18.8283 43.7949 24 43.7949C29.1717 43.7949 34.1316 41.7405 37.7886 38.0835C41.4455 34.4265 43.5 29.4666 43.5 24.2949C43.5 19.1232 41.4455 14.1633 37.7886 10.5063C34.1316 6.84938 29.1717 4.79492 24 4.79492ZM0 24.2949C0 17.9297 2.52856 11.8252 7.02944 7.32436C11.5303 2.82349 17.6348 0.294922 24 0.294922C30.3652 0.294922 36.4697 2.82349 40.9706 7.32436C45.4714 11.8252 48 17.9297 48 24.2949C48 30.6601 45.4714 36.7646 40.9706 41.2655C36.4697 45.7664 30.3652 48.2949 24 48.2949C17.6348 48.2949 11.5303 45.7664 7.02944 41.2655C2.52856 36.7646 0 30.6601 0 24.2949Z"
          fill="#4A90E2"
        />
      </mask>
      <g mask="url(#mask0_2151_8484)">
        <rect
          x="24"
          y="-3.1377"
          width="29.1429"
          height="29.1429"
          fill="#F5F5F5"
        />
        <rect
          x="24"
          y="25.1519"
          width="29.1429"
          height="29.1429"
          fill="#2962FF"
        />
        <rect
          x="-5.14258"
          y="-3.99072"
          width="29.1429"
          height="58.2857"
          fill="#2962FF"
        />
      </g>
    </svg>
  )
}
